import * as React from "react";
import { InjectedIntlProps, injectIntl } from "react-intl";

import { Button, InputNumber, Skeleton } from "antd";
import { CoverMeasurementLifecycle, NodeStatus, PropagationLevel } from "../../store/projects/types";
import { IRowEntry, skeletonProps } from "./covermeasurements";

interface IOwnProps {
    record: IRowEntry;
    copy: boolean;
    isEditingQualityThreshold: (record: IRowEntry) => boolean;
    saveQualityThresholdChange: (newQualityThreshold: number | undefined, key: string) => void;
    editQualityThreshold: (record: IRowEntry) => void;
    cancelQualityThresholdChange: () => void;
}

type AllProps = IOwnProps & InjectedIntlProps;

interface IState {
    currentQualityTreshold?: number;
}

class CovermeasurementQualityThreshold extends React.PureComponent<AllProps, IState> {
    constructor(props: AllProps) {
        super(props);
        this.state = {
            currentQualityTreshold: props.record.propagatedCoverdepthQualityThreshold.value
        };
    }

    onQualityTresholdChanged(value: number | undefined) {
        this.setState({
            ...this.state,
            currentQualityTreshold: value
        });
    }

    render() {
        const {
            record,
            copy,
            isEditingQualityThreshold,
            saveQualityThresholdChange,
            cancelQualityThresholdChange,
            editQualityThreshold
        } = this.props;

        if (record.status === CoverMeasurementLifecycle.Draft) {
            return <Skeleton {...skeletonProps} />;
        } else if (record.status === CoverMeasurementLifecycle.Error) {
            return "—";
        } else {
            let qualityThresholdString: string;
            let textStyle: any = { float: "left", color: "#bbb" };

            if (record.coverdepthQualityThreshold) {
                qualityThresholdString = record.coverdepthQualityThreshold.toString();
                textStyle = { float: "left" };
            } else {
                switch (record.propagatedCoverdepthQualityThreshold.sourceLevel) {
                    case PropagationLevel.PROJECT:
                        qualityThresholdString = `${
                            record.propagatedCoverdepthQualityThreshold.value
                        } (${this.props.intl.formatMessage({
                            id: "project"
                        })})`;
                        break;
                    case PropagationLevel.NODE:
                        qualityThresholdString = `${record.propagatedCoverdepthQualityThreshold.value} (${
                            record.propagatedCoverdepthQualityThreshold.sourceName
                        })`;
                        break;
                    case PropagationLevel.FILE:
                        qualityThresholdString = `${record.propagatedCoverdepthQualityThreshold.value} `;
                        textStyle = { float: "left" };
                        break;
                    default:
                        qualityThresholdString = "";
                }
            }

            if (copy) {
                return (
                    <span>
                        <div style={textStyle}>{qualityThresholdString}</div>
                    </span>
                );
            } else if (isEditingQualityThreshold(record)) {
                return (
                    <span>
                        <InputNumber
                            min={0}
                            defaultValue={this.state.currentQualityTreshold}
                            onChange={this.onQualityTresholdChanged.bind(this)}
                            value={this.state.currentQualityTreshold}
                            placeholder={qualityThresholdString}
                            onKeyUp={e => {
                                if (e.key === "Enter") {
                                    saveQualityThresholdChange(this.state.currentQualityTreshold, record.key);
                                }
                            }}
                            autoFocus={true}
                            onFocus={e => e.target.select()}
                        />
                        <Button
                            size="small"
                            icon="check"
                            onClick={e => {
                                saveQualityThresholdChange(this.state.currentQualityTreshold, record.key);
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            style={{ border: "none", backgroundColor: "rgba(0, 0, 0, 0)" }}
                        />
                        <Button
                            size="small"
                            icon="close"
                            onClick={e => {
                                cancelQualityThresholdChange();
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            style={{ border: "none", backgroundColor: "rgba(0, 0, 0, 0)" }}
                        />
                    </span>
                );
            } else {
                return (
                    <span>
                        {record.nodeStatus !== NodeStatus.DISABLED && (
                            <Button
                                size="small"
                                icon="edit"
                                onClick={() => editQualityThreshold(record)}
                                style={{
                                    float: "left",
                                    marginLeft: 2,
                                    border: "none",
                                    backgroundColor: "rgba(0, 0, 0, 0)"
                                }}
                            />
                        )}
                        <div style={textStyle}>{qualityThresholdString}</div>
                    </span>
                );
            }
        }
    }
}

export default injectIntl(CovermeasurementQualityThreshold);
